/* eslint-disable react/jsx-props-no-spreading */
import React, { InputHTMLAttributes, useEffect, useRef } from 'react';
import { useField } from '@unform/core';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  className?: string;
}

const InputUnform: React.FC<InputProps> = ({ name, ...props }) => {
  const inputRef = useRef(null);

  const {
    fieldName, defaultValue, error, registerField,
  } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <>
      <input ref={inputRef} defaultValue={defaultValue} {...props} />
      <span className="text-danger">{error}</span>
    </>
  );
};

InputUnform.defaultProps = {
  className: undefined,
};

export default InputUnform;
